console.log('header.js file loaded');

function initHeader() {
    console.log('Initializing header functionality');
    const hamIcon = $('.header-right-900-icon');
    const hamburgerIcon = $('.hamburger-icon');
    const nav = $('.header-right-900');
    
    console.log('Found hamburger icon container:', hamIcon.length, 'hamburger icon:', hamburgerIcon.length);
    console.log('Found nav:', nav.length);
    
    function openMenu() {
      nav.addClass('active'); 
      hamburgerIcon.addClass('active');
      $('body').css('overflow-y', 'hidden');
      $('.header-bg').css('display','block');
    }
    
    function closeMenu() {
      nav.removeClass('active');
      hamburgerIcon.removeClass('active');
      $('body').css('overflow-y', 'auto');
      $('.header-bg').css('display','none');
    }
    
    // ハンバーガーアイコンのコンテナにクリックイベントを設定
    hamIcon.off('click.header').on('click.header', function (e) {
      console.log('Hamburger container clicked', e);
      e.preventDefault();
      e.stopPropagation();
      if (nav.hasClass('active')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
    
    // ハンバーガーアイコン自体にクリックイベントを設定
    hamburgerIcon.off('click.header').on('click.header', function (e) {
      console.log('Hamburger icon clicked', e);
      e.preventDefault();
      e.stopPropagation();
      if (nav.hasClass('active')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
    
    $('.header-bg').off('click.header').on('click.header', function(e){
      console.log('Header bg clicked', e);
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
    });
    
    $('.header-right-link-900').off('click.header').on('click.header', function(e){
      console.log('Header link clicked', e);
      closeMenu();
    });
}

$(document).on('turbolinks:load', function() {
    console.log('Turbolinks load event fired in header.js');
    initHeader();
});

// 初回読み込み時にも実行
$(document).ready(function() {
    console.log('Document ready in header.js');
    initHeader();
});


